import { useSelector } from 'react-redux'
import type { TFunction } from 'i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectAdditionalSaleDataByName } from '../../SubscriptionForm/SubscriptionFormSelectors'
import { productTitle } from './productDisplay'
import { saleProductStatus } from './saleProductStatus'
import { progressDefinitionOf } from './saleProgressRegistry'
import type { SaleAuthData } from './types'

interface UseProductListItemParams {
  saleKey: string
  onSelect: (key: string) => void
  t: TFunction
}

const useProductListItem = ({ saleKey, onSelect, t }: UseProductListItemParams) => {
  const { country }: SaleAuthData = useSelector(selectAuthData) ?? {}
  const saleData = useSelector(selectAdditionalSaleDataByName(saleKey))
  const isFrance = (country ?? '').toLowerCase() === 'fr'
  const status = saleProductStatus(saleData, isFrance ? progressDefinitionOf(saleKey) : undefined, {
    country: country ?? '',
  })

  const select = () => onSelect(saleKey)

  return {
    status,
    label: productTitle(t, saleKey),
    statusLabel: status === 'idle' ? null : t(`additionalSales:pulse.status_label.${status}`),
    select,
  }
}

export default useProductListItem
